<template>
  <a-config-provider :locale="zhCN">
    <div id="app">
      <div
        class="dd-spin-container"
        v-show="$store.state.loading"
      >
        <a-spin tip="请稍后…"> </a-spin>
      </div>
      <router-view />
    </div>
  </a-config-provider>

</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
  name: "App",
  data() {
    return {
      zhCN
    }
  }
}
</script>
<style lang="scss">
html {
  font-size: 24px;
}
body {
  font-size: 0.58333rem;
}
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  position: relative;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.dd-spin-container {
  height: 100%;
  width: 100%;
  position: absolute;
  text-align: center;
  top: 0px;
  left: 0px;
  z-index: 100001;
  background: rgba($color: #e6f7ff, $alpha: 0.4);
  padding-top: 20%;
}
.ant-btn-primary {
  background: #0d1944;
  border-color: #1300bb;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus {
  background: #4d4e4e;
  border-color: #1300bb;
}
.ant-modal-header {
  padding: 8px 24px;
  background: rgba(146, 147, 148, 0.1);
  font-family: FZLanTingHei-DB-GBK;
  font-weight: 400;
  color: #3b3b3b;
}
.ant-modal-close-x {
  width: 38px;
  height: 38px;
  line-height: 38px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  boder-radius: 10px;
  background: rgba(255, 255, 255, 0);
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0);
  filter: alpha(opacity=0);
  -moz-opacity: 0;
  -khtml-opacity: 0;
  opacity: 0;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  background: rgba(255, 255, 255, 1);
  filter: alpha(opacity=20);
  -moz-opacity: 0.2;
  -khtml-opacity: 0.2;
  opacity: 0.2;
}
.ol-print {
  display: none !important;
}
</style>
